export default function UploadProgressBar({ progress, label = "Uploading..." }) {
  if (progress == null || progress < 0) return null;

  return (
    <div className="w-full" aria-live="polite">
      <div className="flex items-center justify-between text-sm text-[#777777] mb-1">
        <span>{label}</span>
        <span>{progress}%</span>
      </div>
      <div className="h-2 w-full bg-[#eeeeee] rounded overflow-hidden">
        <div
          className="h-full bg-[#f26522] transition-all duration-200 ease-out"
          style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
        />
      </div>
    </div>
  );
}
